import { useState } from "react";
import { InputBox } from "../Inputs/InputBox";

function Slider(props) {
  const [value, setValue] = useState(props.value);

  function onSliderChange(event) {
    setValue(event.target.value);

    if (typeof props.onChange === "function") props.onChange(event);
  }

  return (
    <div style={{ display: "flex", alignItems: "center", margin: "0 auto" }}>
      <div style={{ flexGrow: 0 }}>{props.title}</div>
      <div
        style={{
          flex: 1,
          padding: "0px 10px 6px",
          display: props.editable ? "inline" : "none",
        }}
      >
        <input
          type={"range"}
          id={props.id}
          step={props.step}
          min={props.min}
          max={props.max}
          value={props.editable ? value : props.value}
          onChange={onSliderChange.bind(this)}
        />
      </div>
      <div name="inputBox" style={{ flexGrow: 0, paddingLeft: "20px" }}>
        <InputBox
          title={props.inputTitle}
          id={props.id + "Input"}
          step={props.step}
          min={props.min}
          max={props.max}
          unit={props.unit}
          decimalPlaces={0}
          editable={props.editable}
          value={props.editable ? value : props.value}
          onChange={onSliderChange.bind(this)}
        />
      </div>
    </div>
  );
}

export default Slider;
